export const navbarScrollListen = async () => {
    let lastScrollTop = 0;
    window.addEventListener('scroll', function () {
        var scrollDistance = window.scrollY;
        let navbar = document.querySelector(".navbar");
        let hamburger = document.querySelector(".navbar__hamburger");
        if (scrollDistance > lastScrollTop) {
            // Scrolling down
            if (scrollDistance > 1) {
                navbar.classList.add("navbar--follow");
                hamburger.classList.add("hamburger--follow");
            }
        } else {
            // Scrolling up
            if (scrollDistance < 100) {
                
                navbar.classList.remove("navbar--follow");
                hamburger.classList.remove("hamburger--follow");
            }
          
        }
        lastScrollTop = scrollDistance <= 0 ? 0 : scrollDistance; // Update lastScrollTop to the current position
    });
}
